// To be used for the heading part of
// MF only

import * as React from "react";
import DeviceContext from "./../../../../service/indentifyDevice";

export interface IOpQuotesHeadingMfDskProps {
	SchemeName?: string;
	nav?: number;
	changeinnav?: number;
	changeinnavper?: number;
	navdateformat?: string;
}

const OpQuotesHeadingMfDsk: React.FC<IOpQuotesHeadingMfDskProps> = props => {
	// input: date in the format => DDo MMMM YYYY
	// output: date in the format => DD MMM YYYY
	function changeDateFormat(date: string) {
		let splitDate = date.split(" ");
		splitDate[0] = splitDate[0].slice(0, 2); // get the number part only (starts with 0 if less than 10)
		splitDate[1] = splitDate[1].slice(0, 3); // get the first three chars of month
		return splitDate.join(" ");
	}

	return (
		<div className="op_quotes_heading op_quotes_heading_mf">
			<h1 className="symbol">{props.SchemeName || "--"}</h1>
			<div className="right_mob">
				<div className="small mf">NAV - ({props.navdateformat && changeDateFormat(props.navdateformat)})</div>
				{!DeviceContext().isTablet && (
					<div className="nav_change">
						<span className="nav">{props.nav !== undefined ? props.nav : "--"}</span>
						<span className="change green">
							{props.changeinnav !== undefined ? props.changeinnav : "--"}{" "}
							{props.changeinnavper !== undefined ? `(${props.changeinnavper}%)` : "--"}
						</span>
					</div>
				)}
			</div>
		</div>
	);
};

export default OpQuotesHeadingMfDsk;
